import { Link } from 'react-router-dom';
import { Trash2, Clock, RotateCcw, AlertTriangle } from 'lucide-react';
import { useTranslation } from 'react-i18next';

interface DeletedItemsCardProps {
  className?: string;
}

export default function DeletedItemsCard({ className = '' }: DeletedItemsCardProps) {
  const { t } = useTranslation('archives');

  return (
    <div className={`bg-white rounded-xl shadow-sm border border-gray-200 overflow-hidden ${className}`}>
      {/* En-tête */}
      <div className="bg-gradient-to-r from-orange-50 to-amber-50 px-6 py-4 border-b border-orange-100">
        <div className="flex items-center gap-3">
          <div className="p-2 bg-orange-100 rounded-lg">
            <Trash2 className="w-5 h-5 text-orange-600" />
          </div>
          <div>
            <h3 className="font-semibold text-gray-900">{t('card.title')}</h3>
            <p className="text-sm text-gray-600">{t('card.subtitle')}</p>
          </div>
        </div>
      </div>

      {/* Contenu */}
      <div className="p-6 space-y-4">
        <p className="text-gray-600 text-sm">
          {t('card.description')}
        </p>

        {/* Points clés */}
        <div className="space-y-3">
          <div className="flex items-start gap-3">
            <div className="p-1.5 bg-blue-50 rounded-lg mt-0.5">
              <Clock className="w-4 h-4 text-blue-600" />
            </div>
            <div>
              <p className="text-sm font-medium text-gray-900">{t('card.retention30Days')}</p>
              <p className="text-xs text-gray-500">{t('card.retentionDescription')}</p>
            </div>
          </div>

          <div className="flex items-start gap-3">
            <div className="p-1.5 bg-green-50 rounded-lg mt-0.5">
              <RotateCcw className="w-4 h-4 text-green-600" />
            </div>
            <div>
              <p className="text-sm font-medium text-gray-900">{t('card.restorePossible')}</p>
              <p className="text-xs text-gray-500">{t('card.restoreDescription')}</p>
            </div>
          </div>

          <div className="flex items-start gap-3">
            <div className="p-1.5 bg-red-50 rounded-lg mt-0.5">
              <AlertTriangle className="w-4 h-4 text-red-600" />
            </div>
            <div>
              <p className="text-sm font-medium text-gray-900">{t('card.permanentDeletion')}</p>
              <p className="text-xs text-gray-500">{t('card.permanentDeletionDescription')}</p>
            </div>
          </div>
        </div>

        {/* Bouton d'accès */}
        <Link
          to="/dashboard/elements-supprimes"
          className="w-full mt-4 flex items-center justify-center gap-2 px-4 py-2.5 bg-orange-600 hover:bg-orange-700 text-white rounded-lg transition-colors font-medium"
          data-tutorial="deleted-items-button"
        >
          <Trash2 className="w-4 h-4" />
          {t('card.viewDeletedItems')}
        </Link>
      </div>
    </div>
  );
}
